import React, {Component} from 'react';

class InterviewQues extends Component {
  render() {
    const { interviewQuesVOs, i18n, themeColor, handleClick, selectedIndex } = this.props;
    return (
      <ul className="interviewQues">
        {interviewQuesVOs && interviewQuesVOs.map((item, index) => (
          <li key={index} onClick={() => handleClick(item.questionId, index)} style={selectedIndex === index ? {color: themeColor, borderColor: themeColor} : {}}>
            {selectedIndex === index && <i style={{backgroundColor: themeColor}} />}
            <div className="interviewQuesTextBox">
              <p>Q{index + 1}：</p>
              <p>{i18n.lang === 'en_us' ? item.enName : item.cnName}</p>
            </div>
          </li>
        ))}
      </ul>
    );
  }
}

export default InterviewQues;
